/**
 * @license Copyright (c) Microsoft Corporation.  All rights reserved.
 */
var __awaiter = (this && this.__awaiter) || function (thisArg, _arguments, P, generator) {
    function adopt(value) { return value instanceof P ? value : new P(function (resolve) { resolve(value); }); }
    return new (P || (P = Promise))(function (resolve, reject) {
        function fulfilled(value) { try { step(generator.next(value)); } catch (e) { reject(e); } }
        function rejected(value) { try { step(generator["throw"](value)); } catch (e) { reject(e); } }
        function step(result) { result.done ? resolve(result.value) : adopt(result.value).then(fulfilled, rejected); }
        step((generator = generator.apply(thisArg, _arguments || [])).next());
    });
};
var __generator = (this && this.__generator) || function (thisArg, body) {
    var _ = { label: 0, sent: function() { if (t[0] & 1) throw t[1]; return t[1]; }, trys: [], ops: [] }, f, y, t, g;
    return g = { next: verb(0), "throw": verb(1), "return": verb(2) }, typeof Symbol === "function" && (g[Symbol.iterator] = function() { return this; }), g;
    function verb(n) { return function (v) { return step([n, v]); }; }
    function step(op) {
        if (f) throw new TypeError("Generator is already executing.");
        while (g && (g = 0, op[0] && (_ = 0)), _) try {
            if (f = 1, y && (t = op[0] & 2 ? y["return"] : op[0] ? y["throw"] || ((t = y["return"]) && t.call(y), 0) : y.next) && !(t = t.call(y, op[1])).done) return t;
            if (y = 0, t) op = [op[0] & 2, t.value];
            switch (op[0]) {
                case 0: case 1: t = op; break;
                case 4: _.label++; return { value: op[1], done: false };
                case 5: _.label++; y = op[1]; op = [0]; continue;
                case 7: op = _.ops.pop(); _.trys.pop(); continue;
                default:
                    if (!(t = _.trys, t = t.length > 0 && t[t.length - 1]) && (op[0] === 6 || op[0] === 2)) { _ = 0; continue; }
                    if (op[0] === 3 && (!t || (op[1] > t[0] && op[1] < t[3]))) { _.label = op[1]; break; }
                    if (op[0] === 6 && _.label < t[1]) { _.label = t[1]; t = op; break; }
                    if (t && _.label < t[2]) { _.label = t[2]; _.ops.push(op); break; }
                    if (t[2]) _.ops.pop();
                    _.trys.pop(); continue;
            }
            op = body.call(thisArg, _);
        } catch (e) { op = [6, e]; y = 0; } finally { f = t = 0; }
        if (op[0] & 5) throw op[1]; return { value: op[0] ? op[1] : void 0, done: true };
    }
};
import { MktFeatureConfigurationEntityProvider, MktFeatureServiceClient } from "@cxp-shared/feature-flags";
import { getCdsClientUrl } from "@cxp-shared/services/CDS/Utils";
import { FetchClient } from "@cxp-shared/fetch-client";
import { TelemetryService, ConsoleTelemetryProvider, XrmTelemetryProvider, } from "@cxp-shared/services/Telemetry";
export function createTelemetryService(component) {
    return new TelemetryService([
        new ConsoleTelemetryProvider("CXP-Forms-WebResource"),
        new XrmTelemetryProvider("CXP-Forms-WebResource"),
    ]).cloneForComponent(component);
}
var createGlobalTelemetryService = function () {
    var service = null;
    return function () {
        if (!service) {
            service = createTelemetryService("FormsWebresource");
        }
        return service;
    };
};
var telemetryService = createGlobalTelemetryService();
var FeatureFlagResolver = /** @class */ (function () {
    function FeatureFlagResolver() {
    }
    FeatureFlagResolver.isBusinessUnitScopingFeatureEnabled = function () {
        return __awaiter(this, void 0, void 0, function () {
            return __generator(this, function (_b) {
                return [2 /*return*/, FeatureFlagResolver.isFeatureEnabled(FeatureFlagResolver.businessUnitScopingFeatureId)];
            });
        });
    };
    FeatureFlagResolver.isBusinessUnitEnabledInCRM = function () {
        var _b;
        try {
            var organizationSettings = Xrm.Utility.getGlobalContext().organizationSettings;
            var orgdborgsettings = ((_b = organizationSettings === null || organizationSettings === void 0 ? void 0 : organizationSettings.attributes) === null || _b === void 0 ? void 0 : _b.orgdborgsettings) || "";
            return (orgdborgsettings.match(/<EnableOwnershipAcrossBusinessUnits>true<\/EnableOwnershipAcrossBusinessUnits>/gi) || []).length > 0;
        }
        catch (e) {
            return false;
        }
    };
    FeatureFlagResolver.isBusinessUnitFeatureEnabled = function () {
        return __awaiter(this, void 0, void 0, function () {
            var isBusinessUnitEnabledCrm, isBusinessUnitFeatureOn;
            return __generator(this, function (_b) {
                switch (_b.label) {
                    case 0:
                        isBusinessUnitEnabledCrm = FeatureFlagResolver.isBusinessUnitEnabledInCRM();
                        return [4 /*yield*/, FeatureFlagResolver.isBusinessUnitScopingFeatureEnabled()];
                    case 1:
                        isBusinessUnitFeatureOn = (_b.sent());
                        telemetryService().logFunctionalEvent("mktBUFeatureEnabled", {
                            EnableOwnershipAcrossBusinessUnits: "".concat(isBusinessUnitEnabledCrm),
                            isMktBusinessUnitFeatureOn: "".concat(isBusinessUnitFeatureOn)
                        });
                        return [2 /*return*/, isBusinessUnitEnabledCrm && isBusinessUnitFeatureOn];
                }
            });
        });
    };
    FeatureFlagResolver.isFormCaptureFeatureEnabled = function () {
        return __awaiter(this, void 0, void 0, function () {
            return __generator(this, function (_b) {
                return [2 /*return*/, FeatureFlagResolver.isFeatureEnabled(FeatureFlagResolver.formCaptureFeatureId)];
            });
        });
    };
    FeatureFlagResolver.isDoubleOptInFeatureEnabled = function () {
        return __awaiter(this, void 0, void 0, function () {
            return __generator(this, function (_b) {
                return [2 /*return*/, FeatureFlagResolver.isFeatureEnabled(FeatureFlagResolver.doubleOptInFeatureId)];
            });
        });
    };
    FeatureFlagResolver.isWaitlistFeatureEnabled = function () {
        return __awaiter(this, void 0, void 0, function () {
            return __generator(this, function (_b) {
                return [2 /*return*/, FeatureFlagResolver.isFeatureEnabled(FeatureFlagResolver.waitlistFeatureId)];
            });
        });
    };
    var _a;
    _a = FeatureFlagResolver;
    FeatureFlagResolver.businessUnitScopingFeatureId = "6508310d-8dfd-4812-b476-74398ca18ee7";
    FeatureFlagResolver.formCaptureFeatureId = "9a25352d-b985-4283-bf01-3a38f26cc92b";
    FeatureFlagResolver.doubleOptInFeatureId = "5bd338c5-e31f-4ede-af43-2ab87f6b79e1";
    FeatureFlagResolver.waitlistFeatureId = "ef3f255b-9aa4-4783-bceb-339e29b75b3f";
    FeatureFlagResolver.createCachedFeatureGetter = function () {
        var cdsBaseUrl = getCdsClientUrl();
        var mktFeatureFlagServiceClient = new MktFeatureServiceClient(cdsBaseUrl, new FetchClient(), new MktFeatureConfigurationEntityProvider(cdsBaseUrl, new FetchClient()));
        var features = {};
        return function (id) { return __awaiter(void 0, void 0, void 0, function () {
            var featureValue;
            return __generator(_a, function (_b) {
                switch (_b.label) {
                    case 0:
                        if (Object.keys(features).indexOf(id) > -1) {
                            return [2 /*return*/, features[id]];
                        }
                        return [4 /*yield*/, mktFeatureFlagServiceClient.isFeatureEnabled(id)];
                    case 1:
                        featureValue = _b.sent();
                        features[id] = featureValue;
                        return [2 /*return*/, featureValue];
                }
            });
        }); };
    };
    FeatureFlagResolver.isFeatureEnabled = FeatureFlagResolver.createCachedFeatureGetter();
    return FeatureFlagResolver;
}());
export { FeatureFlagResolver };
